import React, { useEffect, useState } from "react"
import FollowUpVisit from "../../components/FollowUpVisit"
import "./ConsultantApprovalRequest.scss"
import Button from "../../components/Button"
import InputField from "../../components/InputField"
import { useHistory } from "react-router"
import {
  approveRejectPendingRequests,
  getPendingApprovalRequestById,
  getSmartSummaryDetails,
} from "../../core/services/api"
import { getPatientDetail } from "../../core/services/api"
import { useLocation } from "react-router-dom"
import RenderSummaryHeader from "../../components/SummaryView/components/RenderSummaryHeader/RenderSummaryHeader"
import RenderDiagnosticReport from "../../components/SummaryView/components/RenderDiagnosticReport/RenderDiagnosticReport"
import Toast from "../../components/Toast"
import { calculateAge } from "core/utils/date"

export default function ConsultantApprovalRequest() {
  const [reason, setReason] = useState("")
  const [pendingApprovalResult, setPendingApprovalResult] = useState<any>()
  const [smartSummaryResult, setSmartSummaryResult] = useState<any>({})
  const [patientDetail, updatePatientDetail] = React.useState<any>()
  const [isApproved, setIsApproved] = useState(false)
  const [isRejected, setIsRejected] = useState(false)
  const [isReasonEmpty, setIsReasonEmpty] = useState(false)
  const [reasonDisable, setReasonDisable] = useState(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const location = useLocation()
  const id = location?.state?.idValue
  const patinetId = location?.state?.patientIdValue
  const recordId = location?.state?.recordIdValue
  const history = useHistory()

  const element = document?.getElementById("consultant-approval-request-wrapper")

  function scroll() {
    const element = document?.getElementById("consultant-approval-request-wrapper")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  const fetchSmartSummaryDetails = () => {
    getSmartSummaryDetails(patinetId)
      .then((res) => {
        setSmartSummaryResult(res)
      })
      .catch(() => {
        console.error("err")
      })
  }
  const fetchPendingApprovalRequestDetails = () => {
    getPendingApprovalRequestById(id)
      .then((res: any) => {
        setPendingApprovalResult(res)
        if (res?.reason) {
          setReason(res?.reason)
          setReasonDisable(true)
        }
      })
      .catch(() => {
        console.error("err")
      })
  }

  const fetchPatientInfo = () => {
    getPatientDetail(patinetId)
      .then((res) => {
        updatePatientDetail(res)
      })
      .catch((err) => {
        console.error("err", err)
      })
  }

  const handleSubmit = (e: any) => {
    if (e.target?.innerText == "Approve") {
      const approvalReqDetail: any = {
        rmoId: pendingApprovalResult.rmoId,
        consultantId: pendingApprovalResult.consultantId,
        patientId: pendingApprovalResult.patientId,
        recordId: pendingApprovalResult.recordId,
        centerId: pendingApprovalResult.centerId,
        status: "APPROVED",
        approvalFor: pendingApprovalResult.approvalFor,
        reason: reason,
        appointmentDate: pendingApprovalResult.pendingApprovalResult,
      }
      approveRejectPendingRequests(approvalReqDetail, id)
        .then((res) => {
          setIsLoading(false)
          setIsApproved(true)
          setPendingApprovalResult(res)
          if (res?.reason) {
            setReason(res?.reason)
            setReasonDisable(true)
          }
        })
        .catch((err) => {
          setIsLoading(false)
          console.error("err", err)
        })
    }
    if (e.target?.innerText == "Reject") {
      const rejectReqDetail: any = {
        rmoId: pendingApprovalResult.rmoId,
        consultantId: pendingApprovalResult.consultantId,
        patientId: pendingApprovalResult.patientId,
        recordId: pendingApprovalResult.recordId,
        centerId: pendingApprovalResult.centerId,
        status: "REJECTED",
        approvalFor: pendingApprovalResult.approvalFor,
        reason: reason,
        appointmentDate: pendingApprovalResult.pendingApprovalResult,
      }
      approveRejectPendingRequests(rejectReqDetail, id)
        .then((res) => {
          setIsLoading(false)
          setIsRejected(true)
          setPendingApprovalResult(res)
          if (res?.reason) {
            setReason(res?.reason)
          }
        })
        .catch((err) => {
          setIsLoading(false)
          console.error("err", err)
        })
      // }
    }
  }

  useEffect(() => {
    if (element) {
      scroll()
    }
  }, [element])

  useEffect(() => {
    fetchSmartSummaryDetails()
    fetchPendingApprovalRequestDetails()
    fetchPatientInfo()
  }, [])

  return (
    <div id="consultant-approval-request-wrapper" className="consultant-approval-request-wrapper">
      {isApproved ? (
        <Toast
          textMessage={`Approved Successfully`}
          type="success"
          onCloseText={"Close"}
          onClose={() => {
            setIsApproved(false)
            history.push({
              pathname: "/viewAllRequest",
              state: {
                tabValue: 0,
              },
            })
          }}
        ></Toast>
      ) : isRejected ? (
        <Toast
          textMessage={`Rejected Successfully`}
          type="success"
          onCloseText={"Close"}
          onClose={() => {
            setIsRejected(false)
            history.push({
              pathname: "/viewAllRequest",
              state: {
                tabValue: 0,
              },
            })
          }}
        ></Toast>
      ) : isReasonEmpty ? (
        <Toast
          textMessage={`Please enter reason for Approval/Rejection`}
          type="error"
          onCloseText={"Close"}
          onClose={() => setIsReasonEmpty(false)}
        ></Toast>
      ) : isLoading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      ) : (
        ""
      )}
      <div className="heading-container">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push({
              pathname: "/viewAllRequest",
              state: {
                tabValue: 0,
              },
            })
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
          Pending Approval Requests
        </div>
      </div>
      <div className="first-section">
        <div className="d-flex justify-content-around">
          <div className="d-flex">
            <label className="labels">RMO:</label>&nbsp;
            <div className="rmo_name">{pendingApprovalResult?.rmoName}</div>
          </div>

          <div className="d-flex">
            <label className="labels">Patient ID:</label>&nbsp;
            <div className="rmo_name">{pendingApprovalResult?.patientMocId}</div>
          </div>
          <div className="d-flex">
            <label className="labels">Patient Name:</label>&nbsp;
            <div className="rmo_name">
              {pendingApprovalResult?.isVIP
                ? pendingApprovalResult?.patientMocId
                : pendingApprovalResult?.patientName}
            </div>
          </div>
          <div className="d-flex">
            <label className="labels">Age:</label>&nbsp;
            <div className="rmo_name">{calculateAge(patientDetail?.dob)}</div>
          </div>
          <div className="d-flex">
            <label className="labels">Center:</label>&nbsp;
            <div className="rmo_name">{pendingApprovalResult?.center}</div>
          </div>
        </div>
        <div className="first-section-details">
          <div className="row issueDetails">
            {pendingApprovalResult?.approvalFor}
          </div>
        </div>
      </div>
      <div></div>

      <div>
        <div className="second-section">
          <div className="second-section-heading">Smart Summary</div>
          <div className="border_for_smart_summary">
            <RenderSummaryHeader
              patientDetail={patientDetail}
              smartSummaryData={smartSummaryResult}
            />
            <RenderDiagnosticReport
              smartSummaryData={smartSummaryResult}
            />
          </div>
        </div>
      </div>
      {!pendingApprovalResult?.isExtraVitalsReq && (
        <div className="third-section">
          <FollowUpVisit
            ignoreAutopopulatedFollowUp={true}
            isEditable={false}
            id={recordId ? recordId : ""}
            isReadOnly={true}
            smartSummaryData={smartSummaryResult}
            consultantRequest={true}
          />
        </div>
      )}
      <div className="approve-reject-container">
        {/* <form> */}
        <div className="row nameDetails">
          <div className="col-md-1">
            <label className="textlabel">Reason:</label>
          </div>

          <div className="col-md-11">
            <InputField
              placeholder="Enter reason for Approval/Rejection"
              value={reason}
              readOnly={reasonDisable}
              handleChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className="button-alignment">
          <div>
            <Button
              text="Approve"
              type="submit"
              onClick={(e) => handleSubmit(e)}
              disabled={
                pendingApprovalResult?.status === "APPROVED" ||
                  pendingApprovalResult?.status === "REJECTED"
                  ? true
                  : false
              }
              id="approve"
            />
          </div>
          <div>
            <Button
              text="Reject"
              type="submit"
              outline={true}
              onClick={(e) => handleSubmit(e)}
              disabled={
                pendingApprovalResult?.status === "APPROVED" ||
                  pendingApprovalResult?.status === "REJECTED"
                  ? true
                  : false
              }
              id="reject"
            />
          </div>
        </div>
        {/* </form> */}
      </div>
    </div>
  )
}
